module.exports = __webpack_public_path__ + "img/Flag_of_Malta.342c213b.svg";